<template>
    <v-dialog :value="value" @click:outside="$emit('close')" width="55%">
      <v-card>
        <v-toolbar flat style="cursor: default;">
          <v-toolbar-title class="ml-2 title"><v-icon left>mdi-file-upload-outline</v-icon>
            Upload Credit Request Form
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-col class="d-flex justify-end">
            <v-btn
              id="uploadBtn"
              color="primary"
              class="mr-4"
              :loading="loading"
              :disabled="loading"
              @click="downloadForm">
              <v-icon>mdi-file-download-outline</v-icon>
              Download Form
            </v-btn>
            <v-btn
              id="saveAndUploadNewBtn"
              color="success"
              class="mr-4"
              :loading="loading"
              :disabled="loading || (!file || !selectedStore)"
              @click="upload">
              <v-icon>mdi-file-upload-outline</v-icon>
              Submit
            </v-btn>
          </v-col>
        </v-toolbar>
        <v-col>
          <v-file-input
            v-model="file"
            outlined
            dense
            hide-details="auto"
            truncate-length="100"
            label="File"
            @change="handleFile">
          </v-file-input>
          </v-col>
        <v-col>
          <v-autocomplete
            v-model="selectedStore"
            :items="storeSelections"
            return-object
            :item-text="getItemText"
            :item-value="isJBGRetailer ? 'id': 'store_id'"
            outlined
            dense
            hide-details="auto"
            label="Store"
            clearable
            @click:clear="selectedStore = null">
            <template v-slot:prepend-inner>
              <v-icon>mdi-magnify</v-icon>
            </template>
          </v-autocomplete>
          </v-col>
      </v-card>
    </v-dialog>
</template>
<script>
// api
import document from '@/axios/document'
import Party from '@/axios/party'
// mixin
import { displayAlert } from "@/mixins/alert"

export default {
  name: 'CreditUploadDialog',
  props: {
    value: Boolean,
    stores: Array,
    isJBGRetailer: Boolean,
  },
  data() {
    return {
      file: null,
      loading: false,
      selectedStore: null,
      allStores: []
    }
  },
  mixins: [displayAlert],
  async created() {
    if (!this.isJBGRetailer) {
      const res = await Party.getAllStoresForTenant()
      if (res) this.allStores = res.data
    }
  },
  computed: {
    storeSelections() {
      return this.isJBGRetailer ? this.stores : this.allStores
    }
  },
  methods: {
    async downloadForm () {
      try {
        this.emitAlert(true, 'info', "Template downloading", [], true)
        const response = await document.downloadCreditRequestTemplate()
        if (response?.data?.url) {
          const url = response.data.url
          window.open(url, '_blank')
        }
      } catch (err) {
        console.error(err)
        this.emitAlert(true, 'error', "Error while downloading template")
      }
    },
    getItemText(item) {
      return this.isJBGRetailer ? `${item.name}` : `#${item.wholesaler_store_number} ${item.store_name}`
    },
    handleFile (file) {
      if (!file) return
      const reader = new FileReader()
      reader.onload = (e) => {
        this.file.upload_file = e.target.result
      }
      reader.readAsArrayBuffer(file)
    },
    async upload () {
      this.loading = true
      try {
        await this.uploadFile()
        this.loading = false
        this.emitAlert(true, 'success', 'Credit Request Submitted', [], true)
        this.$emit('update:value', false)
        this.eventbus.$emit('refreshDocuments')
        this.file = null
      } catch (err) {
        this.loading = false
        // Route through handleError so a read-only 403 shows the friendly toolkit
        // message instead of the raw "Request failed with status code 403".
        this.handleError(err)
      }
    },
    async uploadFile () {
      try {
        const file = this.file
        const blob = new Blob([file.upload_file], { type: file.type })
        const formData = new FormData()
        formData.append('name', file.name)
        formData.append('upload_file', blob, file.name)
        formData.append('store_id', this.isJBGRetailer ? this.selectedStore.id : this.selectedStore.store_party_id)

        const tags = {
          category: "RETAILER_REPORT",
          subcategory: "RETAILER_CREDIT_REQUEST",
          status: "CURRENT"
        }

        const pathEnv = `${process.env.VUE_APP_FILE_PATH}`

        formData.append('path', `${pathEnv}/${tags.category}/${tags.subcategory}`)
        return await document.upload(this.$auth.user.email, formData, tags)
      } catch (err) {
        console.error(err)
        throw err
      }
    },
  }
}
</script>